import { createAsyncThunk } from '@reduxjs/toolkit'
import { getMemberBenefitsPage, MemberBenefitsPageParams } from '../../../services/memberBenefits'
import { RootThunkApi } from '../../../app/store'
import { sendAsync } from '../../../app/applicationSlice'


export const getAddItemPageAsync = createAsyncThunk<
  void,
  MemberBenefitsPageParams,
  RootThunkApi
>('addItem/getPage', async (params, api) => {
  return sendAsync(getMemberBenefitsPage(params), api)
})
